import React, { useEffect, useState } from "react";
import Formulaire from "../../components/Formulaire";
import Layout from "../../layout/Layout";
import { useMutation, useQuery, useQueryClient } from "react-query";
import Table from "../../components/Table";
import {
  createEntite,
  getEntite,
  updateEntite,
  deleteEntite,
} from "../../services/entite";
import ReactPaginate from "react-paginate";
import Loading from "../../components/Loading";
const Entites = () => {
  const headTable = [
    { name: "Libellé ", width: "100%" },
    { name: "", width: "5%" },
  ];
  const [current, setCurrent] = useState(null);
  const forms = [
    {
      label: "Libellé (*)",
      type: "text",
      name: "libelle",
      values: current?.LIBELLE ?? "",
    },
  ];

  // const [entites, setEntites] = useState([]);

  const [flash, setFlash] = useState({ message: null, color: "success" });

  // pagination code
  let PageSize = 10;
  const [isLoading, setIsLoading] = useState(false);
  const [currentTableData, setCurrentTableData] = useState([]);
  const [tableData, setTableData] = useState([]);

  const [totalPage, setTotalPage] = useState(null);
  const page = (currentPage, datas) => {
    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;

    return datas.slice(firstPageIndex, lastPageIndex);
  };

  const onPageChange = (e) => {
    const d = page(parseInt(e.selected + 1), tableData);
    setCurrentTableData(d);
    // console.log(d);
  };
  // fin code pagination

  const queryClient = useQueryClient();
  const query = useQuery(["entites"], getEntite);

  const fetchEntite = async () => {
    setIsLoading(true);
    getEntite()
      .then((res) => {
        const { data, message } = res;
        const d = page(1, data);
        setCurrentTableData(d);
        const coutPage = parseInt(data.length / PageSize);
        setTotalPage(coutPage);
        setTableData(data);
        setFlash({ ...flash, message, color: "success" });
        setIsLoading(false);
      })
      .catch();
  };
  const { mutate } = useMutation(createEntite, {
    onSuccess: async ({ data, message }) => {
      // Invalidate and refetch

      setIsLoading(true);
      setFlash({ ...flash, message, color: "success" });
      getEntite()
        .then((res) => {
          const { data, message } = res;
          const d = page(1, data);
          setCurrentTableData(d);
          const coutPage = parseInt(data.length / PageSize);
          setTotalPage(coutPage);
          setTableData(data);
          setIsLoading(false);
        })
        .catch();

      // queryClient.invalidateQueries("entites");
    },
    onSettled: ({ response: { data } }) => {
      setFlash({ ...flash, message: data.message, color: "danger" });
      // console.log(data.message);
    },
  });

  const { mutate: updateMutate } = useMutation(updateEntite, {
    onSuccess: async ({ data, message }) => {
      // Invalidate and refetch
      setIsLoading(true);
      setFlash({ ...flash, message, color: "success" });
      getEntite()
        .then((res) => {
          const { data, message } = res;
          const d = page(1, data);
          setCurrentTableData(d);
          const coutPage = parseInt(data.length / PageSize);
          setTotalPage(coutPage);
          setTableData(data);
          setIsLoading(false);
        })
        .catch();
    },
    onSettled: ({ response: { data } }) => {
      setFlash({ ...flash, message: data.message, color: "danger" });
      // console.log(data.message);
    },
  });

  const postEntite = (data) => mutate(data);
  const putEntite = (data) => updateMutate(data);
  const onclick = (data) => {
    setCurrent(data);
    // setIsLoading(false);
  };

  // delete

  const onDelete = async () => {
    if (window.confirm("Voulez vous supprimer?")) {
      const data = { id: current.ID, nom: current.NOM };
      deleteEntite(data)
        .then(({ data }) => {
          console.log();
          setIsLoading(true);
          setCurrent(null);
          setFlash({ ...flash, message: data.message });
          getEntite()
            .then((res) => {
              const { data, message } = res;
              const d = page(1, data);
              setTableData(data);
              setCurrentTableData(d);
              const coutPage = parseInt(data.length / PageSize);
              setTotalPage(coutPage);
              // setFlash({ ...flash, message: message });

              setIsLoading(false);
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((error) => {
          // console.log(error.response);
          setIsLoading(true);
          setCurrent(null);
          setFlash({
            ...flash,
            color: "danger",
            message: error.response.data.message,
          });
          getEntite()
            .then((res) => {
              const { data, message } = res;
              const d = page(1, data);
              setTableData(data);
              setCurrentTableData(d);
              const coutPage = parseInt(data.length / PageSize);
              setTotalPage(coutPage);
              // setFlash({ ...flash, message: message });

              setIsLoading(false);
            })
            .catch((err) => {
              console.log(err);
            });
        });
    }
  };
  // delete

  useEffect(() => {
    fetchEntite();
  }, []);
  return (
    <Layout>
      <Formulaire
        message={flash?.message}
        color={flash?.color}
        forms={forms}
        title={"Gestion des entités"}
        cb={current ? putEntite : postEntite}
        current={current}
        isLoading={isLoading}
        setCurrent={setCurrent}
        onDelete={onDelete}
      />
      {isLoading ? (
        <Loading isLoading={isLoading} />
      ) : (
        <Table headTable={headTable} title={"LISTE DES ENTITES"}>
          {currentTableData?.map((item, key) => (
            <tr key={key} style={{ color: "Black", backgroundColor: "White" }}>
              <td>{item?.LIBELLE}</td>
              <td className="text-center" align="right">
                <img
                  onClick={() => onclick(item)}
                  style={{ width: 15, height: 10 }}
                  src={"/Catef_files/modifier.png"}
                />
              </td>
            </tr>
          ))}
          {/* paginate */}
          <tr
            className="pagination-od"
            align="center"
            style={{
              color: "Black",
              backgroundColor: "#EFF3F8",
              fontWeight: "normal",
              whiteSpace: "nowrap",
            }}
          >
            <td colSpan={5}>
              {totalPage != null && (
                <ReactPaginate
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  containerClassName={"pagination"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  activeClassName={"active"}
                  breakLabel="..."
                  nextLabel="suivant >"
                  onPageChange={onPageChange}
                  pageRangeDisplayed={5}
                  pageCount={totalPage + 1}
                  previousLabel="< précédent"
                  renderOnZeroPageCount={null}
                />
              )}
            </td>
          </tr>
        </Table>
      )}
    </Layout>
  );
};

export default Entites;
